import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { RouterModule } from '@angular/router';
import { HeaderService } from './header.service';
import { MenuModule } from 'primeng/menu';

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, RouterModule, MenuModule],
  providers: [HeaderService],
  exports: [HeaderComponent],
})
export class HeaderModule {}
